import React, { useState } from 'react';
import classnames from 'classnames';
import { Link, graphql, useStaticQuery } from 'gatsby';

import { FiMenu, FiX } from 'react-icons/fi';
import EuroMomo from '../images/euromomo.svg';
import EuroMomoInvert from '../images/euromomo-invert.svg';

import { getWindowProp } from '../utils/dom';

import css from './Menu.module.css';

export const menuItems = [
	{
		name: 'Bulletins'
	},
	{
		name: 'Graphs and maps',
		link: '/graphs-and-maps/'
	},
	{
		name: 'About us',
		slug: '/about-us/',
		link: '/about-us/contact/',
		children: [
			{ name: 'Contact', link: '/about-us/contact/' },
			{ name: 'Partners', link: '/about-us/partners/' },
			{ name: 'History', link: '/about-us/history/' },
			{ name: 'Mission and Vision', link: '/about-us/mission-and-vision/' }
		]
	},
	{
		name: 'How it Works',
		slug: '/how-it-works/',
		link: '/how-it-works/rationale/',
		children: [
			{ name: 'Rationale', link: '/how-it-works/rationale/' },
			{ name: 'Objectives', link: '/how-it-works/objectives/' },
			{ name: 'Methods', link: '/how-it-works/methods/' },
			{ name: 'Reports & Publications', link: '/how-it-works/reports-and-publications/' },
			{ name: 'FluMOMO', link: '/how-it-works/flumomo/' }
		]
	}
];

export default props => {
	const pathname = getWindowProp('location') || '';
	const [menu, setMenu] = useState();
	const toggleMenu = () => {
		setMenu(!menu);
	};

	const data = useStaticQuery(graphql`
		query {
			lastBulletin: allMarkdownRemark(
				sort: { fields: frontmatter___date, order: DESC }
				filter: { fileAbsolutePath: {}, frontmatter: { category: { eq: "bulletins" } } }
				limit: 1
			) {
				edges {
					node {
						fields {
							slug
						}
					}
				}
			}
		}
	`);
	menuItems[0].link = data.lastBulletin.edges[0].node.fields.slug + '/';

	const Logo = props.invert && !menu ? EuroMomoInvert : EuroMomo;
	return (
		<div className={classnames(css.root, { [css.invert]: props.invert })}>
			<h1 className={css.logo}>
				<Link to={'/'}>
					<Logo className={css.logoSvg} alt={props.siteTitle} />
				</Link>
			</h1>
			<a className={classnames(css.burger, { [css.open]: menu })} onClick={toggleMenu}>
				{menu ? <FiX size={32} /> : <FiMenu size={32} />}
			</a>

			<ul className={classnames(css.menu, { [css.open]: menu })}>
				{menuItems.map((item, i) => (
					<li
						className={classnames(css.item, {
							[css.withSubMenu]: item.children,
							[css.active]: item.link == pathname
						})}
						key={i}>
						{item.link ? <Link to={item.link}>{item.name}</Link> : item.name}
						{item.children && (
							<ul className={css.submenu}>
								{item.children.map((subItem, j) => (
									<li className={css.item} key={`${i}-${j}`}>
										{subItem.link ? <Link to={subItem.link}>{subItem.name}</Link> : subItem.name}
									</li>
								))}
							</ul>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};
